/**
 * Build CSV string from array of objects and column definitions.
 * @param {Array<Object>} data - Array of row objects
 * @param {Array<{key: string, label: string}>} columns - Columns with key (data field) and label (CSV header)
 * @returns {string} CSV content
 */
export function buildCsv(data, columns) {
    const header = columns.map((col) => escapeCsvCell(col.label)).join(",");
    const rows = data.map((row) =>
        columns.map((col) => escapeCsvCell(getNestedValue(row, col.key))).join(",")
    );
    return [header, ...rows].join("\r\n");
}

function escapeCsvCell(value) {
    if (value == null) return "";
    const str = String(value);
    if (str.includes(",") || str.includes('"') || str.includes("\n") || str.includes("\r")) {
        return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
}

function getNestedValue(obj, path) {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

/**
 * Trigger browser download of a string as a file.
 * @param {string} content - File content
 * @param {string} filename - Suggested filename
 * @param {string} mimeType - MIME type (default: text/csv)
 */
export function downloadFile(content, filename, mimeType = "text/csv;charset=utf-8;") {
    const blob = new Blob(["\uFEFF" + content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
